import { style } from '@vanilla-extract/css';

export const container = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding:
    'var(--wt-hyperlink-margin-top) calc(var(--wt-hyperlink-margin-right) + var(--wt-padding-right-value-w-fallback)) var(--wt-hyperlink-margin-bottom) calc(var(--wt-hyperlink-margin-left) + var(--wt-padding-left-value-w-fallback))',
});

/** Image column % width on larger breakpoints (default 30% when attr omitted). */
export const artworkColumn = style({
  width: '100%',
  '@media': {
    '(min-width: 640px)': {
      width: 'var(--podcast-embed-image-width-pct, 30%)',
      maxWidth: 'var(--podcast-embed-image-width-pct, 30%)',
    },
  },
});

/** Write mode: same % width at every breakpoint so layout never stacks like mobile email. */
export const artworkColumnWriteMode = style({
  width: 'var(--podcast-embed-image-width-pct, 20%)',
  maxWidth: 'var(--podcast-embed-image-width-pct, 20%)',
  flexShrink: 0,
});
